/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { IKeyText } from "../Interfaces/IKeyText";

export const defaultListingPageSize = 16;

/**
 * TODO: Note that the list of approved by admins is a constant for now until backend work is completed to get up-to-date list.
 * The admin list.
 */
export const ADMIN_LIST: IKeyText[] = [
  {
    key: "v-aablum@microsoft.com",
    text: "v-aablum@microsoft.com",
  },
  {
    key: "v-duran@microsoft.com",
    text: "v-duran@microsoft.com",
  },
  {
    key: "cledev@microsoft.com",
    text: "cledev@microsoft.com",
  },
  {
    key: "v-dmares@microsoft.com",
    text: "v-dmares@microsoft.com",
  },
  {
    key: "David.Molina@microsoft.com",
    text: "David.Molina@microsoft.com",
  },
  {
    key: "mvpprodrobys@microsoft.com",
    text: "mvpprodrobys@microsoft.com",
  },
  {
    key: "Eoin.Murphy@microsoft.com",
    text: "Eoin.Murphy@microsoft.com",
  },
  {
    key: "v-frankz@microsoft.com",
    text: "v-frankz@microsoft.com",
  },
  {
    key: "v-madrsa@microsoft.com",
    text: "v-madrsa@microsoft.com",
  },
  {
    key: "Meghana.Garise@microsoft.com",
    text: "Meghana.Garise@microsoft.com",
  },
  {
    key: "narayar@microsoft.com",
    text: "narayar@microsoft.com",
  },
  {
    key: "v-ncastaneda@microsoft.com",
    text: "v-ncastaneda@microsoft.com",
  },
  {
    key: "pablo.veramendi@microsoft.com",
    text: "pablo.veramendi@microsoft.com",
  },
  {
    key: "v-wsarah@microsoft.com",
    text: "v-wsarah@microsoft.com",
  },
  {
    key: "v-szwu@microsoft.com",
    text: "v-szwu@microsoft.com",
  },
];

/**
 * The list of supported sorting columns.
 * @constant
 */
export const SortingColumns = {
  FirstName: "firstName",
  LastName: "lastName",
  Country: "countryRegion",
};
